var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreDetailsLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FBA63C",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5C12.8094 12.5 13.0743 12.3922 13.2948 12.1766C13.5153 11.961 13.6254 11.7021 13.625 11.4C13.625 11.0975 13.5148 10.8384 13.2943 10.6228C13.0738 10.4072 12.809 10.2996 12.5 10.3C12.1906 10.3 11.9257 10.4078 11.7052 10.6234C11.4847 10.839 11.3746 11.0979 11.375 11.4C11.375 11.7025 11.4853 11.9616 11.7058 12.1772C11.9263 12.3928 12.191 12.5004 12.5 12.5ZM12.5 18C10.9906 16.7442 9.86337 15.5778 9.11825 14.5009C8.37312 13.424 8.00038 12.427 8 11.51C8 10.135 8.45244 9.03958 9.35731 8.22375C10.2622 7.40792 11.3098 7 12.5 7C13.6906 7 14.7384 7.40792 15.6432 8.22375C16.5481 9.03958 17.0004 10.135 17 11.51C17 12.4267 16.6272 13.4236 15.8817 14.5009C15.1362 15.5782 14.009 16.7445 12.5 18Z",
    fill: "#FFA726"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreDetailsLocation);
export default __webpack_public_path__ + "static/media/moreDetailsLocation.f436cd7489a1727d303a089fdeb5d419.svg";
export { ForwardRef as ReactComponent };